// МИНИМАЛЬНАЯ СБОРКА ПРИЛОЖЕНИЯ iOS (ТЗ релиза П2, владелец 29.09.2026).
//
// Числа живут В КОДЕ САЙТА — без админки, без таблиц и без env (решение владельца).
// Менять = катка сайта. Поднимать IOS_MIN_BUILD только тогда, когда сайт перестал
// работать с этой сборкой (или в оболочке нашёлся критичный дефект): все, у кого
// сборка ниже, увидят блокирующее окно «Обновите приложение» (app-update-gate.tsx).
// Файл общий для сервера (/api/version) и клиента — только чистые значения и функции.
import { isAdmAppUa } from './adm/app-ua';

/** Минимальная поддерживаемая сборка iOS (номер build из UA). 0 — проверка выключена. */
export const IOS_MIN_BUILD = 0;

/**
 * ПЕРВАЯ СБОРКА iOS, КОТОРАЯ УМЕЕТ ЭКРАНЫ БЫСТРОГО ЗАПУСКА (QUICK-START §2.0 п.3): строка «Не удалось разобраться?» на
 * «Создать бота» отдаётся только сборкам с номером не ниже этого; старым — прежний блок инструкций. До сборки с новыми
 * элементами — `Number.MAX_SAFE_INTEGER` (никому); номер называет ведущий после сборки Scriptera Dev, меняется коммитом.
 */
export const QUICK_START_MIN_BUILD = 6010;

/** Apple ID приложения в App Store (вышло 10.10.2026, версия 1.1). Тот же номер — в Smart App
 *  Banner главной ([locale]/page.tsx) и в ссылках лендинга по языку (ru → витрина RU, en → US). */
export const IOS_APP_ID = '6792524707';

/** Ссылка на приложение в App Store (общая: Apple сама подставляет страну). Пусто — ссылки нет
 *  (кнопка окна ничего не открывает). */
export const IOS_STORE_URL = `https://apps.apple.com/app/id${IOS_APP_ID}`;

/**
 * Номер сборки из User-Agent оболочки: `ScripteraApp/0.2 (build 241; commit …)` → 241; приложение админки
 * Scriptera A — `ScripteraAdm/<версия> (build N)` (обе подписи, lib/adm/app-ua.ts) → N.
 * Не приложение или сборка без `(build N)` → null (такие считаются старыми: build 0).
 */
export function parseAppBuild(ua: string | null | undefined): number | null {
  if (!ua || !(ua.includes('ScripteraApp') || isAdmAppUa(ua))) return null;
  const m = /(?:ScripteraApp|ScripteraAdm)\/[^\s(]*\s*\(build\s+(\d+)/.exec(ua);
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isFinite(n) ? n : null;
}

/** Нужно ли блокирующее окно: порог включён и сборка ниже (нет номера — считаем 0). */
export function shouldGate(build: number | null | undefined, min: number): boolean {
  if (!Number.isFinite(min) || min <= 0) return false;
  return (build ?? 0) < min;
}
